<template>
  <div v-if="loading" class="text-center mt-5 font-2xl text-muted">
    <i class="fal fa-spinner fa-spin" /> Loading
  </div>
  <div v-else class="animated fadeIn">
    <basic-heading title="Prep Process: Sort Tasks" class="mb-3">
      <template #right-content>
        <header-button-group :button_config="button_config" />
      </template>
    </basic-heading>
    <template v-if="prep_process.id">
      <prep-process-card :prep_process="prep_process" />
      <h2>Tasks</h2>
      <template
        v-if="
          prep_task_collection &&
          prep_task_collection.models &&
          prep_task_collection.models.length
        "
      >
        <sortable-list
          :list="prep_task_collection.models"
          :keyField="'id'"
          :labelField="'name'"
          :groupBy="['name']"
          @onOrderChange="storeOrder"
        />
      </template>
    </template>
  </div>
</template>

<script>
import Vue from "vue";
import VueNotifications from "vue-notifications";
import BasicHeading from "@/components/shared/BasicHeading";
import HeaderButtonGroup from "@/components/shared/headerbuttons/HeaderButtonGroup";
import PrepProcessCard from "@/components/lab/prepprocess/PrepProcessCard";
import SortableList from "@/components/shared/SortableList";
import PrepTaskModel from "@/models/lab/PrepTaskModel";
import { getModel, getCollection } from "@/shared/fetch-utils";
import { notificationOptions } from "@/shared/toast-notification-options";

Vue.use(VueNotifications, notificationOptions);

export default {
  name: "PrepProcessSort",
  components: {
    BasicHeading,
    HeaderButtonGroup,
    PrepProcessCard,
    SortableList,
  },
  data() {
    return {
      loading: true,
      prep_process_id: this.$route.params.prep_process_id || null,
      prep_process: null,
      prep_task_collection: null,
    };
  },
  computed: {
    button_config() {
      return {
        buttons: [
          {
            icon: "fa-list",
            linkto: "/prep-processes",
            title: "Prep process list",
          },
          {
            icon: "fa-eye",
            linkto: `/prep-processes/${this.prep_process_id}`,
            title: "View prep processes",
            variant: "info",
          },
        ],
      };
    },
  },
  methods: {
    async init() {
      const filters = [
        {
          logic: "filterEquals",
          field: "prep_process_id",
          value: this.prep_process_id,
        },
      ];
      const sort = [
        {
          logic: "sortAddAsc",
          field: "order",
        },
      ];

      this.prep_process = await getModel({
        model_type: "prep_process",
        id: this.prep_process_id,
        message: this.$bvToast,
      });
      this.prep_task_collection = await getCollection({
        collection_type: "prep_task",
        filters,
        sort,
        message: this.$bvToast,
      });

      this.loading = false;
    },

    storeOrder(list) {
      list.forEach((list_item, index) => {
        let model = new PrepTaskModel(list_item);

        model.set("order", index);
        model.save();
      });
    },
  },
  mounted() {
    this.loading = true;

    this.init();
  },
};
</script>
